import { toast } from "sonner";

// Opens the pre-filled USMCA Certificate of Origin PDF (3 copies) for a US
// shipment. Fetches with the JWT, then opens the blob; falls back to a download
// when the pop-up is blocked. Operators tick a checkbox in the shipping dialogs
// to trigger this — it is never automatic (user rule Oct 6, 2026).
export async function printUsmca(order, copies = 3) {
  const token = localStorage.getItem("lp_token");
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/orders/${order.id}/usmca-pdf?copies=${copies}`;
  try {
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error((await r.text()).slice(0, 200) || `HTTP ${r.status}`);
    const objUrl = URL.createObjectURL(await r.blob());
    const w = window.open(objUrl, "_blank");
    if (!w) {
      const a = document.createElement("a");
      a.href = objUrl;
      a.download = `USMCA-${order.po_number || "order"}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      toast.warning(`Pop-up blocked — USMCA downloaded. Print ${copies} copies before shipping.`);
    } else {
      toast.success(`USMCA Certificate opened in a new tab (${copies} copies) — print it before shipping.`);
    }
    return true;
  } catch (e) {
    toast.error(`USMCA generation failed: ${String(e).slice(0, 160)}`);
    return false;
  }
}
